import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet-async";
import "../components/Header";

function EventsAndRetreats() {

    const [workshops, setWorkshops] = useState([]);
    const IMAGES_PER_ROW = 4;
    const [visibleRows, setVisibleRows] = useState(1);

    useEffect(() => {
      fetch(
        "https://script.google.com/macros/s/AKfycbxgm3JysOyf1xptv9IBUpgFBTF7SFk5vy9SL_Ov4tT7xW4necWihpoOEsOGvQxdRbChdw/exec"
      )
        .then((res) => res.json())
        .then((data) => setWorkshops(data))
        .catch((err) => console.error("Failed to fetch workshops", err));
    }, []);

    // Generate array of image paths for all 20 images
    const images = Array.from({ length: 20 }, (_, i) => 
        `/assets/images/events-retreats-img/event-${i + 1}.jpg`
    );

    const [isLightboxOpen, setIsLightboxOpen] = useState(false);
    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const visibleCount = visibleRows * IMAGES_PER_ROW;

    // Open lightbox with specific image
    const openLightbox = (index) => {
        setCurrentImageIndex(index);
        setIsLightboxOpen(true);
    };

    // Close lightbox
    const closeLightbox = () => {
        setIsLightboxOpen(false);
    };

    // Navigate to next image
    const nextImage = () => {
        setCurrentImageIndex((prevIndex) => 
            prevIndex === images.length - 1 ? 0 : prevIndex + 1
        );
    };

    // Navigate to previous image
    const prevImage = () => {
        setCurrentImageIndex((prevIndex) => 
            prevIndex === 0 ? images.length - 1 : prevIndex - 1
        );
    };

    // Keyboard navigation
    useEffect(() => {
        const handleKeyPress = (e) => {
            if (!isLightboxOpen) return;
            
            if (e.key === 'Escape') {
                closeLightbox();
            } else if (e.key === 'ArrowRight') {
                nextImage();
            } else if (e.key === 'ArrowLeft') {
                prevImage();
            }
        };

        window.addEventListener('keydown', handleKeyPress);
        return () => window.removeEventListener('keydown', handleKeyPress);
    }, [isLightboxOpen]);

    return (
        <div className="main-top">
            <Helmet>
                <title>Events & Retreats | Adya Yoga</title>
                <meta
                  name="description"
                  content="Explore moments from Adya Yoga events and retreats, plus feedback from past sessions."
                />
                <link rel="canonical" href="https://yogaadya.com/events-and-retreats" />
                <meta name="robots" content="index, follow" />
                <meta property="og:type" content="website" />
                <meta property="og:site_name" content="Adya Yoga" />
                <meta property="og:title" content="Events & Retreats | Adya Yoga" />
                <meta property="og:description" content="Photo gallery and highlights from our events and retreats." />
                <meta property="og:url" content="https://yogaadya.com/events-and-retreats" />
                <meta property="og:image" content="https://yogaadya.com/assets/images/events-retreats-img/event-1.jpg" />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="Events & Retreats | Adya Yoga" />
                <meta name="twitter:description" content="Explore moments from our events and retreats." />
                <meta name="twitter:image" content="https://yogaadya.com/assets/images/events-retreats-img/event-1.jpg" />
            </Helmet>
            <div className="events-retreats-container">
                {/* Header Section */}
                <div className="events-header">
                    <h1 className="events-title">Events & Retreats</h1>
                    <p className="events-subtitle">
                        Discover our transformative yoga events and peaceful retreats captured through beautiful moments
                    </p>
                </div>

                {/* Image Gallery Grid */}
                <div className="image-gallery-grid">
                    {images.slice(0, visibleCount).map((image, index) => (
                        <div 
                            key={index} 
                            className="gallery-item"
                            onClick={() => openLightbox(index)}
                        >
                            <img 
                                src={image} 
                                alt={`Event ${index + 1}`}
                                className="gallery-image"
                                loading="lazy"
                            />
                            <div className="image-overlay">
                                <div className="overlay-content">
                                    <span className="zoom-icon">🔍</span>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
                {visibleCount < images.length && (
                    <div className="text-center" style={{ marginBottom: "40px" }}>
                        <button
                            type="button"
                            className="btn btn-primary"
                            onClick={() => setVisibleRows((prev) => prev + 1)}
                        >
                            Load more photos
                        </button>
                    </div>
                )}

                {/* Lightbox Modal */}
                {isLightboxOpen && (
                    <div className="lightbox-overlay" onClick={closeLightbox}>
                        <div className="lightbox-container" onClick={(e) => e.stopPropagation()}>
                            {/* Close Button */}
                            <button className="lightbox-close" onClick={closeLightbox}>
                                ×
                            </button>

                            {/* Navigation Buttons */}
                            <button className="lightbox-nav lightbox-prev" onClick={prevImage}>
                                ❮
                            </button>
                            <button className="lightbox-nav lightbox-next" onClick={nextImage}>
                                ❯
                            </button>

                            {/* Main Image */}
                            <img 
                                src={images[currentImageIndex]} 
                                alt={`Event ${currentImageIndex + 1}`}
                                className="lightbox-image"
                            />

                            {/* Image Counter */}
                            <div className="lightbox-counter">
                                {currentImageIndex + 1} / {images.length}
                            </div>
                        </div>
                    </div>
                )}


                {/* Upcoming Workshops Section */}
          <div className="row mt-5">
            <div className="col-12">
              <h2 className="text-center mb-4">Past Sessions</h2>
              <div className="row">
                {workshops.map((item, index) => (
                  <div key={index} className="col-md-6 mb-4">
                    <div className="card h-100 shadow-sm">
                      <img
                        src={item["Image"]}
                        alt={item["Discription"]}
                        className="card-img-top img-fluid workshop-image"
                      />
                      <div className="card-body d-flex flex-column">
                        <h5 className="card-title">{item["Discription"]}</h5>
                        <a
                          href={item["FeedbackUrl"]}
                          className="btn btn-primary mt-auto"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Submit Feedback
                        </a>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
            </div>

              

        </div>
    );
}

export default EventsAndRetreats;